import { Slot } from '@radix-ui/react-slot';
import { type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '~/shared/lib/cn';

import { buttonVariants } from './button-variants';

export interface ButtonProperties
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  // eslint-disable-next-line react/require-default-props
  asChild?: boolean;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProperties>(
  (
    {
      className,
      variant,
      size,
      width,
      justify,
      orientation,
      asChild = false,
      ...properties
    },
    reference,
  ) => {
    const Comp = asChild ? Slot : 'button';
    return (
      <Comp
        className={cn(
          buttonVariants({
            variant,
            size,
            width,
            justify,
            orientation,
            className,
          }),
        )}
        ref={reference}
        {...properties}
      />
    );
  },
);
Button.displayName = 'Button';
